import { useSelector } from "react-redux";
import { useState, useEffect, useMemo } from "react";
import Tabs from "components/lib/Shared/Tabs";
import AnnualReturns from "./AnnualReturns";
import FinancialStatements from "./FinancialStatements";
import { Constants } from "config/constants";

const AnnualCompliance = () => {
  const { comments } = useSelector((state) => state.commentsSlice);
  const { transactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );
  const { transactions } = transactionUnderReview.items;
  const yyyyAnnualReturnsTransaction = transactions.find(
    (trx) =>
      trx.changeType === Constants.TRANSACTION_CHANGE_TYPES.YYYY_ANNUAL_RETURNS
  );
  const yyyyFinancialStatementsTransaction = transactions.find(
    (trx) =>
      trx.changeType ===
      Constants.TRANSACTION_CHANGE_TYPES.YYYY_FINANCIAL_STATEMENTS
  );
  const yyyyAnnualReturnsIndex = transactions.findIndex(
    (trx) => trx._id === yyyyAnnualReturnsTransaction?._id
  );
  const yyyyFinancialStatementsIndex = transactions.findIndex(
    (trx) => trx._id === yyyyFinancialStatementsTransaction?._id
  );
  const yyyyAnnualReturnsUpdateEffectPath = buildUpdateEffectPath(
    yyyyAnnualReturnsIndex
  );
  const yyyyFinancialStaementsUpdateEffectPath = buildUpdateEffectPath(
    yyyyFinancialStatementsIndex
  );

  const tabs = useMemo(() => {
    let tempTabs = [];

    if (yyyyAnnualReturnsTransaction) {
      tempTabs.push({
        id: "annualReturns",
        label: "Annual Returns",
      });
    }
    if (yyyyFinancialStatementsTransaction) {
      tempTabs.push({
        id: "financialStatements",
        label: "Financial Statements",
      });
    }

    return tempTabs;
  }, [yyyyAnnualReturnsTransaction, yyyyFinancialStatementsTransaction]);

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  useEffect(() => {
    setSelectedTab(tabs[selectedTabIndex]);
  }, [selectedTabIndex]);

  return (
    <div>
      <div>
        <Tabs
          tabs={tabs}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
        />
      </div>
      <div>
        {selectedTab.id === "annualReturns" && <AnnualReturns />}
        {selectedTab.id === "financialStatements" && <FinancialStatements />}
      </div>
    </div>
  );
};

export default AnnualCompliance;

function buildUpdateEffectPath(sliceIndex) {
  return `transactionSlice.transactionUnderReview.items.transactions.${sliceIndex}`;
}
